module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/eu-1019087b8a58ac24c4ea6304579bdd0f.svg";